import { useMutation, useQueryClient } from '@tanstack/react-query';
import { propertyAmenityApi } from '../api/propertyAmenity.api';
import { propertyAmenityKeys } from '../api/propertyAmenity.keys';
import toast from 'react-hot-toast';

export function useCreatePropertyAmenity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => propertyAmenityApi.create(data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: propertyAmenityKeys.all }); toast.success('Amenity created'); },
    onError: (err: any) => { toast.error(err.response?.data?.message || 'Failed to create'); },
  });
}

export function useUpdatePropertyAmenity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => propertyAmenityApi.update(id, data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: propertyAmenityKeys.all }); toast.success('Amenity updated'); },
    onError: (err: any) => { toast.error(err.response?.data?.message || 'Failed to update'); },
  });
}

export function useDeletePropertyAmenity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => propertyAmenityApi.delete(id),
    onSuccess: () => { qc.invalidateQueries({ queryKey: propertyAmenityKeys.all }); toast.success('Amenity deleted'); },
    onError: (err: any) => { toast.error(err.response?.data?.message || 'Failed to delete'); },
  });
}
